// This may be replaced by the language server in the future.
/* eslint-disable no-template-curly-in-string */
const pythonDefinition = (monaco: any) => [
  {
    label: 'if',
    kind: monaco.languages.CompletionItemKind.Snippet,
    insertText: {
      value: ['if ${1:expression}:', '\t${2:pass}'].join('\n'),
    },
    documentation: 'Code snippet for an if statement',
  },
  {
    label: 'if/else',
    kind: monaco.languages.CompletionItemKind.Snippet,
    insertText: {
      value: ['if ${1:condition}:', '\t${2:pass}', 'else:', '\t${3:pass}'].join('\n'),
    },
    documentation: 'Code snippet for an if statement with else',
  },
  {
    label: 'elif',
    kind: monaco.languages.CompletionItemKind.Snippet,
    insertText: {
      value: ['elif ${1:expression}:', '\t${2:pass}'].join('\n'),
    },

    documentation: 'Code snippet for an elif',
  },
  {
    label: 'else',
    kind: monaco.languages.CompletionItemKind.Snippet,
    insertText: {
      value: ['else:', '\t${1:pass}'].join('\n'),
    },

    documentation: 'Code snippet for an else',
  },
  {
    label: 'while',
    kind: monaco.languages.CompletionItemKind.Snippet,
    insertText: {
      value: ['while ${1:expression}:', '\t${2:pass}'].join('\n'),
    },

    documentation: 'Code snippet for a while loop',
  },
  {
    label: 'while/else',
    kind: monaco.languages.CompletionItemKind.Snippet,
    insertText: {
      value: ['while ${1:expression}:', '\t${2:pass}', 'else:', '\t${3:pass}'].join('\n'),
    },

    documentation: 'Code snippet for a while loop with else',
  },
  {
    label: 'for',
    kind: monaco.languages.CompletionItemKind.Snippet,
    insertText: {
      value: ['for ${1:target_list} in ${2:expression_list}:', '\t${3:pass}'].join('\n'),
    },

    documentation: 'Code snippet for a for loop',
  },
  {
    label: 'for/else',
    kind: monaco.languages.CompletionItemKind.Snippet,
    insertText: {
      value: ['for ${1:target_list} in ${2:expression_list}:', '\t${3:pass}', 'else:', '\t${4:pass}'].join('\n'),
    },

    documentation: 'Code snippet for a for loop with else',
  },
  {
    label: 'try/except',
    kind: monaco.languages.CompletionItemKind.Snippet,
    insertText: {
      value: ['try:', '\t${1:pass}', 'except ${2:expression} as ${3:identifier}:', '\t${4:pass}'].join('\n'),
    },

    documentation: 'Code snippet for a try/except statement',
  },
  {
    label: 'try/finally',
    kind: monaco.languages.CompletionItemKind.Snippet,
    insertText: {
      value: ['try:', '\t${1:pass}', 'finally:', '\t${2:pass}'].join('\n'),
    },

    documentation: 'Code snippet for a try/finally statement',
  },
  {
    label: 'try/except/else',
    kind: monaco.languages.CompletionItemKind.Snippet,
    insertText: {
      value: ['try:', '\t${1:pass}', 'except ${2:expression} as ${3:identifier}:', '\t${4:pass}', 'else:', '\t${5:pass}'].join('\n'),
    },

    documentation: 'Code snippet for a try/except/else statement',
  },
  {
    label: 'try/except/finally',
    kind: monaco.languages.CompletionItemKind.Snippet,
    insertText: {
      value: ['try:', '\t${1:pass}', 'except ${2:expression} as ${3:identifier}:', '\t${4:pass}', 'finally:', '\t${5:pass}'].join('\n'),
    },

    documentation: 'Code snippet for a try/except/finally statement',
  },
  {
    label: 'try/except/else/finally',
    kind: monaco.languages.CompletionItemKind.Snippet,
    insertText: {
      value: [
        'try:',
        '\t${1:pass}',
        'except ${2:expression} as ${3:identifier}:',
        '\t${4:pass}',
        'else:',
        '\t${5:pass}',
        'finally:',
        '\t${6:pass}',
      ].join('\n'),
    },

    documentation: 'Code snippet for a try/except/else/finally statement',
  },
  {
    label: 'with',
    kind: monaco.languages.CompletionItemKind.Snippet,
    insertText: {
      value: ['with ${1:expression} as ${2:target}:', '\t${3:pass}'].join('\n'),
    },

    documentation: 'Code snippet for a with statement',
  },
  {
    label: 'def',
    kind: monaco.languages.CompletionItemKind.Snippet,
    insertText: {
      value: ['def ${1:funcname}(${2:parameter_list}):', '\t${3:pass}'].join('\n'),
    },

    documentation: 'Code snippet for a function definition',
  },
  {
    label: 'def(class method)',
    kind: monaco.languages.CompletionItemKind.Snippet,
    insertText: {
      value: ['def ${1:funcname}(self, ${2:parameter_list}):', '\t${3:pass}'].join('\n'),
    },

    documentation: 'Code snippet for a class method',
  },
  {
    label: 'def(static class method)',
    kind: monaco.languages.CompletionItemKind.Snippet,
    insertText: {
      value: ['@staticmethod', 'def ${1:funcname}(${2:parameter_list}):', '\t${3:pass}'].join('\n'),
    },

    documentation: 'Code snippet for a static class method',
  },
  {
    label: 'def(abstract class method)',
    kind: monaco.languages.CompletionItemKind.Snippet,
    insertText: {
      value: ['def ${1:funcname}(self, ${2:parameter_list}):', '\traise NotImplementedError'].join('\n'),
    },

    documentation: 'Code snippet for an abstract class method',
  },
  {
    label: 'class',
    kind: monaco.languages.CompletionItemKind.Snippet,
    insertText: {
      value: ['class ${1:classname}(${2:object}):', '\t${3:pass}'].join('\n'),
    },

    documentation: 'Code snippet for a class definition',
  },
  {
    label: 'lambda',
    kind: monaco.languages.CompletionItemKind.Snippet,
    insertText: {
      value: ['lambda ${1:parameter_list}: ${2:expression}'].join('\n'),
    },

    documentation: 'Code snippet for a lambda statement',
  },
];

export default pythonDefinition;
